import { render, staticRenderFns } from "./OverlayFade.vue?vue&type=template&id=18f7cf9d&"
import script from "./OverlayFade.vue?vue&type=script&lang=js&"
export * from "./OverlayFade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports